module.exports = "//static.hsappstatic.net/UserPreferencesUI/static-1.23703/images/email.svg"